import {IntegerMask} from '../IntegerMask';
import * as IMask from 'imask';

export class Factory {

    // ########################################

    public create(input: HTMLInputElement, format: string = '(000)000-00-00'): IntegerMask {
        const iMask = new IMask(input, {mask: format});

        return new IntegerMask(input, iMask);
    }

    // ########################################

}